import React, {useEffect} from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import { elb } from '@elbwalker/walker.js';

import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
import { redirectLegacyPath } from '../../util/legacyRedirect';
const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

const  urls = [
  "https://share.hsforms.com/1as6OKeloSBOvs3dsGs_2HA4056k",
  "https://share.hsforms.com/1dKkUiEALTQ-rd78A7weZuw4056k",
  "https://share.hsforms.com/1CyuJ1z7zSiisvHKkyeoboQ4056k",
  "https://share.hsforms.com/1bIG-kE4zT0uCvYwhOzaaRA4056k",
  "https://share.hsforms.com/1O3oBYHGES0y1vzX48gno9Q4056k",
  "https://share.hsforms.com/1eF969ZDkSku5UmlSWL1oCg4056k",
  "https://share.hsforms.com/1eF969ZDkSku5UmlSWL1oCg4056k",
  "https://share.hsforms.com/1o75yDyW0TrmeuB5XgpS1xQ4056k",
  "https://share.hsforms.com/1xz2dKTmnReaD6MjaDDTu0A4056k",
  "https://share.hsforms.com/10MVXxTIjQOuL2mLe4mtwbw4056k",
  "https://share.hsforms.com/1-CISwaaWQFeLb5chdA34WA4056k",
  "https://share.hsforms.com/17S_RUBwjRnqOD0yDPtXEQQ4056k",
  "https://share.hsforms.com/1hWi7_H0ATROh0pHy2KaVvw4056k",
  "https://share.hsforms.com/1yom1GpZYQZypToRTKSLCrg4056k",
  "https://share.hsforms.com/1LF_s0IiJT4KlY-cUaI7vjQ4056k",
  "https://share.hsforms.com/1um4wr2ZbSLu2IihoJWhFkA4056k",
  "https://share.hsforms.com/1nSmhY6TgQHmlnJxCebkt0g4056k",
  "https://share.hsforms.com/1CbPfp2_qQxaMsUCUQ_gX0w4056k",
  "https://share.hsforms.com/1Zn5vfV9OTCOltf3zfGaHQQ4056k"
];


export const CMSPageComponent = props => {

  const { params, pageAssetsData, inProgress, error } = props;
  const pageId = params.pageId || props.pageId;

  const history = useHistory();

  if (pageId.endsWith('-de') || pageId.endsWith('-en') || pageId.endsWith('_en') || pageId.endsWith('-de')) {
    const newPageId = pageId.replace(/-de$|-en$/, '');
    const newPath = history.location.pathname.replace(pageId, newPageId);
    history.push(newPath);
  }else if (!inProgress && error?.status === 404) {
    const legacyRedirect = redirectLegacyPath(history.location);
    if (legacyRedirect) {
      return legacyRedirect;
    }
    return <NotFoundPage />;
  }


  useEffect(() => {
    const processAnchors = () => {
      const anchors = document.getElementsByTagName('a');
      Array.from(anchors).forEach(anchor => {
        const href = anchor.getAttribute('href');
        if (urls.includes(href)) {
          anchor.setAttribute('data-elbaction', 'click:click booking-intent');
        }
      });
    };

    processAnchors();

    const observer = new MutationObserver((mutations) => {
      processAnchors();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => observer.disconnect();
  }, []);



  return (
    <div
    data-elbglobals={`pagetype:${pageId}-page`}
    data-elbcontext={`cmspage:${pageId}`} >
    <PageBuilder
      pageAssetsData={pageAssetsData?.[pageId]?.data}
      inProgress={inProgress}
      schemaType="Article"
    />
      </div>
  );
};

CMSPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const { language } = state.ui;
  return { pageAssetsData, inProgress, error, language };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CMSPage = compose(withRouter, connect(mapStateToProps))(CMSPageComponent);

export default CMSPage;
